export default __webpack_public_path__ + "static/media/vacation_dark.b6f0e98d.png";